import React, { useRef } from "react";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Slide,
  Tooltip,
} from "@mui/material";
import print from "../../Assets/print.svg";
import CloseIcon from "@mui/icons-material/Close";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { CloseOutlined } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import KeywordFilterModal from "./KeywordFilterModal";
const CompetitiveSliderTwo = ({
  openCompetitiveSlide,
  setOpenCompetitiveSlide,
  feedBoxOne,
  allCustomSearchList,
  keywordAddModalOne,
  setKeywordAddModalOne,
  keywordListOne,
  keywordSelectedOne,
  setKeywordSelectedOne,
  expandedSummaryOne,
  loadOne,
  setSkipOne,
  searchOneApi,
  setSearchOneApi,
  saveSearchOne,
  setSaveSearchOne,
  openSearchOne,
  setOpenSearchOne,
  dateOrderOne,
  halflines,
  initialData,
  handleRemoveFeed,
  toggleSummaryOne,
  HandlePrintOne,
  download,
  handleToPDF,
  handleRemoveTags,
  search,
  getNews,
  handleChangeFeedBoxOne,
}) => {
  const truncateText = (text) => {
    return text?.length > 30 ? text?.slice(0, 30) + "..." : text;
  };
  const boxOneRef = useRef();

  return (
    <div>
      <Slide
        direction="left"
        in={openCompetitiveSlide}
        mountOnEnter
        unmountOnExit
        className="aip-filter-mb-slide"
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            bgcolor: "white",
            zIndex: 10,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            overflowX: "hidden",
            overflowY: "auto",
            pb: 20,
          }}
        >
          <div className="m-2">
            {/* Call the close handler here */}
            <div
              onClick={() => setOpenCompetitiveSlide(false)}
              className="mobile-ci-heading-cross"
            >
              <ClearIcon
                onClick={() => {
                  setOpenCompetitiveSlide(false);
                  setKeywordSelectedOne([]);
                }}
              />
            </div>
            <p className="mobile-ci-heading">Competitive Intel Feed</p>
            <p className="mobile-ci-heading-inner">
              {" "}
              <Tooltip
                title={
                  feedBoxOne?.boxData?.org_id
                    ? feedBoxOne.boxData.org_name
                    : feedBoxOne?.boxData?.first_name &&
                        feedBoxOne?.boxData?.last_name
                      ? `${
                          feedBoxOne.boxData.first_name === "jp"
                            ? "JP"
                            : feedBoxOne.boxData.first_name
                        } ${
                          feedBoxOne.boxData.last_name === "nauseef"
                            ? "Nauseef"
                            : feedBoxOne.boxData.last_name
                        }`
                      : feedBoxOne?.boxData?.location
                        ? feedBoxOne?.boxData?.location
                        : feedBoxOne?.boxData?.tags
                          ? feedBoxOne?.boxData?.tags
                          : feedBoxOne?.boxData?.industry
                            ? feedBoxOne?.boxData?.industry
                            : feedBoxOne?.boxData?.request_id
                              ? allCustomSearchList?.find(
                                  (i) =>
                                    i?.request_id ===
                                    feedBoxOne?.boxData?.request_id,
                                )?.custom_query_name
                              : null
                }
                arrow
                placement="top"
              >
                <p className="card-heading-top-slider">
                  {feedBoxOne?.boxData?.org_id
                    ? truncateText(feedBoxOne.boxData.org_name)
                    : feedBoxOne?.boxData?.first_name &&
                        feedBoxOne?.boxData?.last_name
                      ? truncateText(
                          `${
                            feedBoxOne.boxData.first_name === "jp"
                              ? "JP"
                              : feedBoxOne.boxData.first_name
                          } ${feedBoxOne.boxData.last_name}`,
                        )
                      : feedBoxOne?.boxData?.location
                        ? truncateText(feedBoxOne?.boxData?.location)
                        : feedBoxOne?.boxData?.tags
                          ? truncateText(feedBoxOne?.boxData?.tags)
                          : feedBoxOne?.boxData?.industry
                            ? truncateText(feedBoxOne?.boxData?.industry)
                            : feedBoxOne?.boxData?.request_id
                              ? truncateText(
                                  allCustomSearchList?.find(
                                    (i) =>
                                      i?.request_id ===
                                      feedBoxOne?.boxData?.request_id,
                                  )?.custom_query_name,
                                )
                              : null}
                </p>
              </Tooltip>
            </p>

            <div
              className="CI-cards-content col"
              // style={{ marginBottom: "92px" }}
            >
              <div className="adding-content">
                <div className="two-head-comp">
                  <div className="result-tags-icon-comp-slider">
                    <div className="result-tags-icon-comp-inner-slide">
                      <div className="checkbox-result-tag-comp">
                        {/* <input type="checkbox" /> */}
                        <p className="result-comp">
                          {feedBoxOne?.data?.length} Results
                        </p>
                        {/* <p className='ai-tags-comp'>AI Tags</p> */}
                      </div>
                      <div className="copy-threedot-comp">
                        <div className="search_news_container">
                          <div
                            className={
                              openSearchOne
                                ? "wrap-search-news-slider active"
                                : "wrap-search-news-slider"
                            }
                          >
                            <input
                              type="text"
                              className={
                                openSearchOne
                                  ? "input_search_news active"
                                  : "input_search_news"
                              }
                              placeholder="Search..."
                              value={saveSearchOne}
                              onChange={(e) =>
                                setSaveSearchOne(e?.target?.value)
                              }
                              // autoFocus
                            />
                            {openSearchOne ? (
                              <CloseIcon
                                className="threedot-icon-comp"
                                onClick={() => {
                                  setOpenSearchOne(false);
                                  setSearchOneApi(false);
                                  setSaveSearchOne("");
                                  getNews(feedBoxOne?.boxData, "date");
                                }}
                              />
                            ) : (
                              <SearchIcon
                                // src={search}
                                // alt=""
                                onClick={() => {
                                  setOpenSearchOne(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <img src={print} alt="" onClick={HandlePrintOne} />
                      </div>
                    </div>

                    <div className="result-date-icon-comp-slide">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: "5px",
                        }}
                      >
                        <div style={{ position: "relative" }}>
                          <button
                            className="keyword-filter-btn"
                            disabled={searchOneApi}
                            onClick={() => setKeywordAddModalOne(true)}
                          >
                            Keyword Filter <ArrowDropDownIcon />
                          </button>
                          {keywordAddModalOne === true ? (
                            <KeywordFilterModal
                              setKeywordAddModal={setKeywordAddModalOne}
                              dataList={keywordListOne}
                              setFeedBox={setKeywordSelectedOne}
                              feedBox={keywordSelectedOne}
                            />
                          ) : null}
                        </div>
                      </div>

                      <div className="checkbox-result-tag-comp">
                        <img src={halflines} alt="" />
                        <p className="sorted-by-comp">Sorted by date:</p>
                        <FormControl
                          sx={{ m: 1, minWidth: 120 }}
                          className="date-comp-dropdown"
                        >
                          <Select
                            className="date-comp-select"
                            value={dateOrderOne}
                            onChange={handleChangeFeedBoxOne}
                            displayEmpty
                            inputProps={{ "aria-label": "Without label" }}
                          >
                            {/* <MenuItem value="" className="date-comp-menuitem">
                                      <em className="date-comp-em">Date</em>
                                    </MenuItem> */}
                            <MenuItem
                              value="asc"
                              className="date-comp-menuitem"
                            >
                              <em className="date-comp-em">Ascending</em>
                            </MenuItem>
                            <MenuItem
                              value="desc"
                              className="date-comp-menuitem"
                            >
                              <em className="date-comp-em">Descending</em>
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                  </div>
                </div>
                <div ref={boxOneRef}>
                  {feedBoxOne.data?.length ? (
                    <>
                      {keywordSelectedOne?.length ? (
                        <div className="display-kw-ci">
                          {keywordSelectedOne?.map((item) => (
                            <div className="crie_selected_names">
                              {item}{" "}
                              <CloseOutlined
                                onClick={() => handleRemoveTags(item, 2)}
                              />
                            </div>
                          ))}
                        </div>
                      ) : null}
                      {feedBoxOne.data.map((articleData, index) => (
                        <div
                          key={index}
                          className="rest-cont"
                          style={{ pageBreakInside: "avoid" }}
                        >
                          <div className="joi-circle-text-comp">
                            <div className="jo-icon-comp">
                              <p>
                                {feedBoxOne?.boxData?.org_id
                                  ? initialData(feedBoxOne.boxData.org_name)
                                  : feedBoxOne?.boxData?.first_name ||
                                      feedBoxOne?.boxData?.last_name
                                    ? initialData(
                                        `${feedBoxOne.boxData.first_name || ""} ${
                                          feedBoxOne.boxData.last_name || ""
                                        }`.trim(),
                                      )
                                    : feedBoxOne?.boxData?.location
                                      ? initialData(
                                          feedBoxOne?.boxData?.location,
                                        )
                                      : feedBoxOne?.boxData?.tags
                                        ? initialData(feedBoxOne?.boxData?.tags)
                                        : feedBoxOne?.boxData?.industry
                                          ? initialData(
                                              feedBoxOne?.boxData?.industry,
                                            )
                                          : feedBoxOne?.boxData?.request_id
                                            ? initialData(
                                                allCustomSearchList?.find(
                                                  (i) =>
                                                    i?.request_id ===
                                                    feedBoxOne?.boxData
                                                      ?.request_id,
                                                )?.custom_query_name,
                                              )
                                            : null}
                              </p>
                            </div>
                            <div className="updated-cont">
                              <div>
                                <p className="jobsohio-name-comp">
                                  {articleData?.article?.title
                                    ? articleData?.article?.title.length > 25
                                      ? `${articleData?.article?.title.slice(
                                          0,
                                          25,
                                        )}...`
                                      : articleData?.article?.title
                                    : articleData?.title}
                                </p>
                              </div>
                              <div className="both-news-time-comp">
                                <p className="news-comp">
                                  <a
                                    href={
                                      articleData?.article?.url
                                        ? articleData?.article?.url
                                        : articleData?.public_text_link
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {articleData?.article?.url
                                      ? articleData.article.url.split(
                                          "https://",
                                        )[1]?.length > 15
                                        ? articleData.article.url
                                            .split("https://")[1]
                                            .slice(0, 15) + "..."
                                        : articleData.article.url.split(
                                            "https://",
                                          )[1]
                                      : articleData?.public_text_link.split(
                                            "http://",
                                          )[1]?.length > 15
                                        ? articleData?.public_text_link
                                            .split("http://")[1]
                                            .slice(0, 15) + "..."
                                        : articleData?.public_text_link.split(
                                            "http://",
                                          )[1]}
                                  </a>
                                  |
                                </p>
                                <p className="today-comp">
                                  {new Date(
                                    articleData?.article?.date
                                      ? articleData?.article?.date
                                      : articleData?.inserted_date,
                                  ).toLocaleDateString("en-US", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric",
                                  })}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="content-pera-comp">
                            <p className="bold-content-pera-comp">
                              {expandedSummaryOne[index] ? (
                                <>
                                  {articleData.summary}
                                  {articleData.summary.length > 170 && (
                                    <span
                                      onClick={() => toggleSummaryOne(index)}
                                      className="see-more-btn"
                                      style={{
                                        color: "#DA291C",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      Show Less
                                    </span>
                                  )}
                                </>
                              ) : (
                                <>
                                  {articleData.summary.length > 170
                                    ? `${articleData.summary.slice(
                                        0,
                                        articleData.summary.lastIndexOf(
                                          " ",
                                          170,
                                        ),
                                      )}`
                                    : articleData.summary}
                                  {articleData.summary.length > 170 && (
                                    <span
                                      onClick={() => toggleSummaryOne(index)}
                                      className="see-more-btn"
                                      style={{
                                        color: "#DA291C",
                                        cursor: "pointer",
                                        textDecoration: "none",
                                        paddingLeft: "5px",
                                      }}
                                    >
                                      See More
                                    </span>
                                  )}
                                </>
                              )}
                            </p>
                            <div className="Intersect-jb-nf-comp">
                              {articleData?.tags?.map((tag, idx) => (
                                <p key={idx}>
                                  {typeof tag === "string" ? tag : tag.tag}
                                </p>
                              ))}
                            </div>
                          </div>
                          <hr className="hr-tag-ci" />
                        </div>
                      ))}
                    </>
                  ) : (
                    <p className="text-center-result">No results found</p>
                  )}
                </div>
              </div>
              {loadOne ? (
                <div className="dash-cancel-save-btns">
                  <Button
                    className="de_next"
                    onClick={() => setSkipOne((skip) => skip + 10)}
                  >
                    Load More
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        </Box>
      </Slide>
    </div>
  );
};

export default CompetitiveSliderTwo;
